<form autocomplete="off" [formGroup]="consumidorAlterarSenhaForm">

  <div class="row">
    <div class="col-sm-6 offset-sm-3">
      <div class="card">
        <div class="card-header">
          <strong>Alteração de Senha Nota Premiada Bahia</strong>
        </div>

        <div class="card-body">
          <!-- row -->
          <div class="row" *ngIf="erroSenhaAlterada">
            <div class="col-sm-12">
              <div class="alert alert-danger" role="alert">
                {{msgSenhaAlteracao}}
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label for="senhaAtual">Senha Atual</label>
                <input type="password" autocomplete="new-password" class="form-control" name="senhaAtual" id="senhaAtual" formControlName="senhaAtual" maxlength="30">

                <div *ngFor="let error of formErrors.senhaAtual" class="alert alert-danger">
                  {{ error }}
                </div>

              </div>
            </div>
          </div>

          <div class="row" formGroupName="senhaGroup">
            
            <div class="col-sm-12">
              <div class="form-group">
                <label for="senha">Nova Senha</label>
                <input type="password" autocomplete="new-password" class="form-control" name="senha" id="senha" formControlName="senha" maxlength="30">

                <div *ngFor="let error of formErrors['senhaGroup.senha']" class="alert alert-danger">
                    {{ error }}
                </div>
              </div>
            </div>

            <div class="col-sm-12" *ngIf="!senhaAlterada">
              <div class="form-group">
                <label for="cpf">Confirmar Nova Senha</label>
                <input type="password" autocomplete="new-password" class="form-control" name="confirmarSenha" id="confirmarSenha" formControlName="confirmarSenha" maxlength="30">

                <div *ngFor="let error of formErrors['senhaGroup.confirmarSenha']" class="alert alert-danger">
                    {{ error }}
                </div>
              </div>
            </div>

          </div>

          <div class="col-sm-12"  *ngFor="let error of formErrors['senhaGroup']" class="alert alert-danger">
            {{ error }}
          </div>

          <!-- row -->
          <div class="row" *ngIf="!senhaAlterada">
            <div class="col-12">
              <button type="button" class="btn btn-bluelight" (click)="onAlterarSenhaNovo()" [disabled]="!consumidorAlterarSenhaForm.valid"
              data-toggle="tooltip" data-placement="top" title="Alterar Senha">
                Alterar Senha
              </button> &nbsp;
              <button type="button" class="btn btn-danger" (click)="cancelaAlterarSenha()"
              data-toggle="tooltip" data-placement="top" title="Cancelar">
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</form>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-senha-logado/consumidor-senha-logado.component.html